// React
import React, { useEffect, useState, useRef, useContext } from "react";
// React
// CSS
import styles from "./ShopModal.module.css";
// CSS
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// Contexts
// Utils
import HelperHeader from "../../../Utils/HelperHeader/HelperHeader";
// Utils
// Images
import { dialog_shop_header } from "../../../Images/images";
// Images
// Models
import { I_ShopItem } from "../../../Models/interfaces";
import { buyProductService } from "../../../Services/Buy/post/buyProductService";
import Spinner from "../../../Utils/Spinner/Spinner";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { getUserProfile_Service } from "../../../Services/Profile/get/getUserProfile_Service";
// Models

type ShowModalProps = {
  setIsModalInScreen: React.Dispatch<React.SetStateAction<boolean>>;
  productData: I_ShopItem;
};

const ShopModal: React.FunctionComponent<ShowModalProps> = ({
  setIsModalInScreen,
  productData: { title, price, gift_price, id, has_paid },
}) => {
  const [isPending, setIsPending] = useState<boolean>(false);
  const [isWalletPending, setIsWalletPending] = useState<boolean>(true);
  const [wallet, setWallet] = useState<number>(0);
  const [giftWallet, setGiftWallet] = useState<number>(0);
  const [payWithWallet, setPayWithWallet] = useState<number>(0);
  const [payWithGiftWallet, setPayWithGiftWallet] = useState<number>(0);
  const [finalPrice, setFinalPrice] = useState<number>(Number(price) + Number(gift_price));
  //
  const userToken = useContext(UserTokenContext);
  //
  //   const buttonRef = useRef<any>(null);
  //
  const modalContainerRef = useRef<HTMLDivElement>(null);
  //
  const innerContentsRef = useRef<HTMLDivElement>(null);
  //
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      if (!modalContainerRef.current) return;
      modalContainerRef.current.style.opacity = "1";
      setTimeout(() => {
        if (!innerContentsRef.current) return;
        innerContentsRef.current.style.top = "0%";
      }, 100);
    }, 100);
  }, []);

  useEffect(() => {
    let final_price = Number(price) + Number(gift_price);
    if (payWithGiftWallet) {
      if (final_price > giftWallet) {
        final_price -= giftWallet;
      } else {
        final_price = 0;
      }
    }
    if (payWithWallet) {
      if (final_price > wallet) {
        final_price -= wallet;
      } else {
        final_price = 0;
      }
    }
    setFinalPrice(final_price);
  }, [payWithWallet, payWithGiftWallet, wallet, giftWallet, price, gift_price]);

  useEffect(() => {
    if (has_paid) {
      setIsWalletPending(false);
    } else {
      getUserProfile_Service(userToken)
        .then(({ data: { data } }) => {
          setWallet(data.wallet);
          setGiftWallet(data.gift_wallet);
          // console.log(data);
          setIsWalletPending(false);
        })
        .catch((err: any) => {
          setIsWalletPending(false);
          toast(
            err.response.data.message ? err.response.data.message : err.message
          );
        });
    }
  }, [userToken]);
  //
  function download(url: string) {
    const a: HTMLAnchorElement = document.createElement("a");
    a.href = url.replace(/(http[^\s])/i, "https:").replace("::", ":");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  return (
    <div
      className={`${styles.shopModalContainer} w-full h-full flex items-center justify-center fixed z-10`}
      ref={modalContainerRef}
    >
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      <div
        className={`${styles.outer} absolute`}
        onClick={() => {
          if (!innerContentsRef.current) return;
          innerContentsRef.current.style.top = "-80%";
          setTimeout(() => {
            if (!modalContainerRef.current) return;
            modalContainerRef.current.style.opacity = "0";
            setTimeout(() => {
              setIsModalInScreen(false);
            }, 100);
          }, 400);
        }}
      ></div>
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      <div
        className={`${styles.inner} h-max px-4  py-6 bg-white flex flex-col items-end justify-start`}
        ref={innerContentsRef}
      >
        <HelperHeader absoluteText=" خریــــد محـــــصول " isBgWhite={true} />
        <img src={dialog_shop_header} alt="" />
        <h1 className=" text-xs">{title}</h1>
        <p className="mt-6">
          <span>مبلغ قابل پرداخت : </span>
          <span>{Number(price + gift_price).toLocaleString('fa-Ir')}</span>
        </p>{" "}
        {/* <p className="mt-1">
          <span>مبلغ کیف پول هدیه : </span>
          <span>{Number(gift_price).toLocaleString("fa-Ir")}</span>
        </p> */}
        {
          !has_paid ?
            (
              <>
                <p className="mt-6" style={{ display: "flex", direction: "rtl" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input disabled={!giftWallet} className="ml-2" onChange={() => { setPayWithGiftWallet((state) => state ? 0 : 1) }} type="checkbox" />
                    <label>کیف پول هدیه : </label>
                  </div>
                  <div>
                    {isWalletPending ?
                      (<SkeletonTheme
                        baseColor="rgba(126, 58, 229 , 0.1)"
                        highlightColor="rgba(126, 0, 229, 0.6)"
                      >
                        <Skeleton
                          count={1}
                          width={"40px"}
                          height={"20px"}
                          style={{ marginRight: "10px" }}
                        />
                      </SkeletonTheme>)
                      :
                      (<span className="mr-1">{giftWallet}</span>)
                    }
                  </div>
                </p>
                <p className="mt-1" style={{ display: "flex", direction: "rtl" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input disabled={!wallet} className="ml-2" onChange={() => { setPayWithWallet((state) => state ? 0 : 1) }} type="checkbox" />
                    <label>کیف پول اصلی : </label>
                  </div>
                  <div>
                    {isWalletPending ?
                      (<SkeletonTheme
                        baseColor="rgba(126, 58, 229 , 0.1)"
                        highlightColor="rgba(126, 0, 229, 0.6)"
                      >
                        <Skeleton
                          count={1}
                          width={"40px"}
                          height={"20px"}
                          style={{ marginRight: "10px" }}
                        />
                      </SkeletonTheme>)
                      :
                      (<span className="mr-1">{wallet}</span>)
                    }
                  </div>
                </p>
              </>
            )
            : ""
        }

        <button
          className={`${styles.submitBtn} w-full py-2 mt-4 text-white rounded-lg flex items-center justify-center`}
          onClick={() => {
            setIsPending(true);

            buyProductService(userToken, id, payWithWallet, payWithGiftWallet)
              .then(({ data }) => {
                if (data.file_path) {
                  download(data.file_path);
                  setIsPending(false);
                  toast("دانلود آغاز شد");
                  setIsModalInScreen(false);
                  return;
                }
                if (data.url) {
                  window.location.href = data.url;
                  setIsPending(false);
                }
                setIsPending(false);
              })
              .catch((err) => {
                console.log(err);
                setIsPending(false);
                toast(
                  err.response.data.message
                    ? err.response.data.message
                    : err.message
                );
              });
          }}
          dir="rtl"
        >
          {isPending || isWalletPending ? (
            <>
              <Spinner />
            </>
          ) : has_paid ? (
            <>دانلود فایل</>
          ) : (
            (Number(price) + Number(gift_price)) === 0 ? (
              <>استفاده ی رایگان</>
            ) : (
              <>
                <span>پرداخت</span>
                <span className={"mr-1 " + ((payWithWallet || payWithGiftWallet) ? 'line-through' : '')}>{Number(price) + Number(gift_price)} تومان</span>
                {
                  (payWithWallet || payWithGiftWallet) ?
                    (<span className="mr-2">{finalPrice} تومان</span>) : ""
                }
              </>
            )
          )}
        </button>
      </div>
    </div>
  );
};

export default ShopModal;
